import { render, staticRenderFns } from "./ApprSubm.vue?vue&type=template&id=793a0e50&scoped=true"
import script from "./ApprSubm.vue?vue&type=script&lang=js"
export * from "./ApprSubm.vue?vue&type=script&lang=js"
import style0 from "./ApprSubm.vue?vue&type=style&index=0&id=793a0e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793a0e50",
  null
  
)

export default component.exports